import React from 'react';
import styles from './Checkbox.module.scss';
function Checkbox({ ...rest }) {
  return <input type="checkbox" {...rest} />;
}

export default Checkbox;
